import { Box, Skeleton, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { RootState } from "../../../store/store";
import Alert from "./Alert/Alert";
import { AlertsStyles } from "./AlertsStyles";
import React, { useEffect, useMemo, useState } from "react";
import { getUserPreferences } from "../../../store/user/profile/profileActions";
import moment from "moment";
import { IAlert } from "../../../models/user/alert/alert";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import Payment from "../../Payment/Payment";
import CustomDrawer from "../../../common/CustomDrawer/CustomDrawer";
import CustomSkeleton from "../../../common/CustomSkeleton/CustomSkeleton";

const Alerts: React.FC = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation();

  const { features } = useAppSelector((state) => state.features);

  const { isLoading, calledReducerType } = useAppSelector(
    (state) => state.common
  );

  const { userDetails } = useAppSelector((state) => state.userAuth);

  const { userSelectedPreferences } = useAppSelector((state) => state.profile);

  const { policiesData } = useAppSelector(
    (state: RootState) => state.dashboard
  );

  const [openPaymentDialogOpen, setOpenPaymentDialogOpen] =
    useState<boolean>(false);
  const [currentSelectedAmount, setCurrentSelectedAmount] =
    useState<string>("");
  const [policyNumber, setPolicyNumber] = useState<string>("No Policy");

  const handlePayNow = (amount: string, carrierPolicyNumber: string) => {
    setPolicyNumber(carrierPolicyNumber);
    setCurrentSelectedAmount(amount);
    setOpenPaymentDialogOpen(true);
  };

  const handlePaymentDialogeClose = () => {
    setOpenPaymentDialogOpen(false);
  };

  const alerts: IAlert[] = useMemo(() => {
    const alerts: IAlert[] = [];
    if (
      userDetails &&
      policiesData &&
      policiesData.policyList &&
      policiesData.policyList.length > 0 &&
      userSelectedPreferences
    ) {
      if (userSelectedPreferences.length === 0) {
        policiesData.policyList.forEach((policy) => {
          if (
            policy.dueDate &&
            policy.dueAmount &&
            moment(policy.dueDate).diff(moment(), "days") <= 7
          ) {
            alerts.push({
              insuredName:
                policy?.insuredName && policy?.insuredName.trim() !== ""
                  ? policy?.insuredName.trim()
                  : policy?.insuredList && policy?.insuredList.length > 0
                  ? policy?.insuredList[0]?.businessName || ""
                  : "",
              carrierPolicyNo: policy.carrierPolicyNo,
              dueAmount: policy.dueAmount,
              dueDate: policy.dueDate,
              lobCode: policy?.lobCode,
            });
          }
          // if (policy.isLegalNotice) {
          //   alerts.push({
          //     insuredName: userDetails?.customerName,
          //     carrierPolicyNo: policy.carrierPolicyNo,
          //     isLegalNotice: policy.isLegalNotice,
          //   });
          // }
          // if (policy.isRefundAvailable) {
          //   policy.refunds.forEach((refund) =>
          //     alerts.push({
          //       insuredName: userDetails?.customerName,
          //       carrierPolicyNo: policy.carrierPolicyNo,
          //       isRefundAvailable: policy.isRefundAvailable,
          //       refund: refund,
          //     })
          //   );
          // }
        });
      } else {
        policiesData.policyList.forEach((policy) => {
          if (policy.dueDate && policy.dueAmount) {
            const daysToDueDate = moment(policy.dueDate).diff(moment(), "days");
            if (
              userSelectedPreferences.some(
                (userPreference) =>
                  userPreference.preferenceType === "paymentRemainder" &&
                  userPreference.preferenceChannel === "pushNotifications" &&
                  parseInt(userPreference.duration) >= daysToDueDate
              )
            ) {
              alerts.push({
                insuredName:
                  policy?.insuredName && policy?.insuredName.trim() !== ""
                    ? policy?.insuredName.trim()
                    : policy?.insuredList && policy?.insuredList.length > 0
                    ? policy?.insuredList[0]?.businessName || ""
                    : "",
                carrierPolicyNo: policy.carrierPolicyNo,
                dueAmount: policy.dueAmount,
                dueDate: policy.dueDate,
                lobCode: policy?.lobCode,
              });
            }
          }
          // if (policy.isLegalNotice) {
          //   alerts.push({
          //     insuredName: userDetails?.customerName,
          //     carrierPolicyNo: policy.carrierPolicyNo,
          //     isLegalNotice: policy.isLegalNotice,
          //   });
          // }
          // if (policy.isRefundAvailable) {
          //   policy.refunds.forEach((refund) =>
          //     alerts.push({
          //       insuredName: userDetails?.customerName,
          //       carrierPolicyNo: policy.carrierPolicyNo,
          //       isRefundAvailable: policy.isRefundAvailable,
          //       refund: refund,
          //     })
          //   );
          // }
        });
      }
    }
    return alerts;
  }, [policiesData, userSelectedPreferences, userDetails]);

  useEffect(() => {
    if (
      userDetails &&
      userDetails.customerId &&
      calledReducerType === "dashboard/getClaimsData"
    ) {
      dispatch(getUserPreferences(userDetails.customerId));
    }
  }, [userDetails, calledReducerType, dispatch]);

  function handleClose(): void {
    setOpenPaymentDialogOpen(false);
  }

  return (
    <>
      {isLoading && calledReducerType === "profile/getUserPreferences" ? (
        <CustomSkeleton count={2} height={"100px"} direction="column" />
      ) : features.some(
          (feature: any) => feature.featureCode === "alerts" && feature.selected
        ) && alerts.length > 0 ? (
        <Box
          sx={AlertsStyles.AlertCardStyles}
          id="customerdashboard_alerts-card"
          data-test-id="test-customerdashboard_alerts-card"
          aria-label="Alerts section"
        >
          {/* <Typography
            sx={AlertsStyles.heading}
            id="customerdashboard_alerts-heading"
            data-test-id="test-customerdashboard_alerts-heading"
            aria-label="Alerts heading"
          >
            {t("Alertsss")}
          </Typography> */}
          {alerts.map((alert: IAlert, index: number) => (
            <Alert
              key={`${alert.carrierPolicyNo}_${index}`}
              alert={alert}
              handlePayNow={handlePayNow}
            />
          ))}
        </Box>
      ) : (
        <></>
      )}

      <CustomDrawer
        content={
          <Payment
            amount={currentSelectedAmount}
            carrierPolicyNumber={policyNumber}
          />
        }
        drawerStyles={{
          "& .MuiDrawer-paper": {
            width: { sm: "50%", xl: "750px" },
          },
        }}
        open={openPaymentDialogOpen}
        onClose={handlePaymentDialogeClose}
        title={`${t("Payment for Policy Number")} : ${policyNumber}`}
      />
    </>
  );
};

export default Alerts;
